import React from 'react'

class Dependants extends React.Component {
  render() {
    const {
      value,
      text,
      active,
      disabled,
      numberOfDependents,
      handleNumberOfDependents,
    } = this.props

    const activeClassName = active ? 'active' : null

    return (
      <div className='card card-single'>
        <div className='card-body'>
          <div className='qn'>
            How many dependants do you have?
          </div>
          <div className='row'>
            <div className='col-8 col-sm-4'>
              <div className='input-group input-plus-minus'>
                <span className='input-group-btn'>
                  <button id="minus" disabled={ disabled } className='btn btn-line btn-number' onClick={handleNumberOfDependents}>
                    <div id="minus" className='material-icons m-auto' onClick={handleNumberOfDependents}>
                      remove
                    </div>
                  </button>
                </span>
                <input className='form-control input-number' value={numberOfDependents} readOnly />
                <span className='input-group-btn'>
                  <button id="plus" disabled={ disabled } className='btn btn-line btn-number' onClick={handleNumberOfDependents}>
                    <div id="plus" className='material-icons m-auto' onClick={handleNumberOfDependents}>
                      add
                    </div>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <br/>
        </div>
      </div>
    )
  }
}

export default Dependants;
